export default {"src":"/_next/static/media/circleCheckmark_disabled_24.64407430.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};